const work = {
    state: {
        workStatusLog: [],
        workTestingMsg: {},
        workWechatMsg: []
    },
    mutations: {
        ADD_WORK_STATUS_LOG(state, { sub_id, data }) {
            state.workStatusLog.unshift({
                'robotid': sub_id,
                'message': data.msg,
                'time': new Date().getTime()
            })
        },
        ADD_WORK_TESTING_MSG(state, { sub_id, data }) {
            state.workTestingMsg = {
                'robotid': sub_id,
                'data': {
                    software: data.software,
                    bridge: data.bridge,
                    wechat: data.wechat,
                    mysql: data.mysql
                }
            }
        },
        ADD_WORK_WECHAT_MSG(state, { sub_id, data }) {
            state.workWechatMsg.unshift({
                'robotid': sub_id,
                'data': data,
                'time': new Date().getTime()
            })
        },
    },

    actions: {
        // 接收机器人状态日志
        receiveWorkStatusLog({ commit }, { sub_id, data }) {
            commit('ADD_WORK_STATUS_LOG', { sub_id, data })
        },
        // 接收机器人状态日志
        receiveWorkTestingMsg({ commit }, { sub_id, data }) {
            commit('ADD_WORK_TESTING_MSG', { sub_id, data })
        },
        // 接收机器人微信消息
        receiveWorkWechatMsg({ commit }, { sub_id, data }) {
            commit('ADD_WORK_WECHAT_MSG', { sub_id, data })
        }
    }
}
export default work
